import { CallApi, handleJSONResponse } from './common';
import { Collaborator } from '@services/collaborator/types/collaborator';
import { NewCollaborator } from '@services/collaborator/types/new-collaborator';

const callAPI = CallApi('collaborators');

export const list = async (assetId: string): Promise<Collaborator[]> => {
  const response = await callAPI(`/${assetId}`, 'GET');

  return handleJSONResponse(response);
};

export const create = async (
  newCollaborator: NewCollaborator
): Promise<Collaborator> => {
  const response = await callAPI(
    `/${newCollaborator.assetId}`,
    'POST',
    newCollaborator
  );

  return handleJSONResponse(response);
};

export const update = async (
  collaborator: Collaborator
): Promise<Collaborator> => {
  const response = await callAPI(
    `/${collaborator.assetId}/${encodeURIComponent(collaborator.id)}`,
    'PUT',
    collaborator
  );

  return handleJSONResponse(response);
};

export const updateOrder = async (
  assetId: string,
  newOrder: string[]
): Promise<string[]> => {
  const response = await callAPI(`/${assetId}/order`, 'PUT', newOrder);

  return handleJSONResponse(response);
};

export const remove = async (
  assetId: string,
  collaboratorId: string
): Promise<any> => {
  const response = await callAPI(
    `/${assetId}/${encodeURIComponent(collaboratorId)}`,
    'DELETE'
  );

  return handleJSONResponse(response);
};
